// import React from "react";

// export default function Header2() {

//     return (
//         <div
//           style={{
//             height: 60,
//             backgroundColor: "lightskyblue",
//             color: "white",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             fontWeight: "bold",
//           }}
//         >
//           Header 2
//         </div>
//       );        
//}

import React, { createContext, useEffect, useState } from 'react';
import Connection from './Hook/Connection';
import Publisher from './Hook/Publisher';
import Subscriber from './Hook/Subscriber';
import Receiver from './Hook/Receiver';
//import mqtt from 'mqtt';
import mqtt from "precompiled-mqtt";

export const QosOption = createContext([])
const qosOption = [
  {
    label: '0',
    value: 0,
  }, {
    label: '1',
    value: 1,
  }, {
    label: '2',
    value: 2,
  },
];

const Header2 = () => {
  const [client, setClient] = useState(null);
  const [isSubed, setIsSub] = useState(false);
  const [payload, setPayload] = useState({});
  const [connectStatus, setConnectStatus] = useState('Connect');

  const mqttConnect = (host, mqttOption) => {
    setConnectStatus('Connecting');
    setClient(mqtt.connect(host, mqttOption));
  };

  useEffect(() => {
    if (client) {
      client.on('connect', () => {
        setConnectStatus('Connected');
      });
      client.on('error', (err) => {
        console.error('Connection error: ', err);
        client.end();
      });
      client.on('reconnect', () => {
        setConnectStatus('Reconnecting');
      });
      client.on('message', (topic, message) => {
        const payload = { topic, message: message.toString() };
        setPayload(payload);
        console.log(payload);
        var VN1 = "Pr1";
        //   var VN1 = this.name.substring(this.name.lastIndexOf("_")+1);
        //     var objLocal1 = {};
        //     objLocal1.pw1   = 0;

        //     if(objLocal1.pw1==0){objLocal1.pw1=1} else {objLocal1.pw1=0};
	
        //     document.dispatchEvent(new CustomEvent(VN1, {detail: {name: VN1, values: JSON.stringify(objLocal1) }  }));
        //     document.dispatchEvent(new CustomEvent("mqtt1Send1", {detail: { name: VN1, values: JSON.stringify(objLocal1) } }));
        //window.dispatchEvent(new CustomEvent("mqtt1Rx1", payload));
        //window.dispatchEvent(new CustomEvent("mqtt1Rx1", {detail: {name: VN1, values: JSON.stringify(payload) }  }));
        // document.dispatchEvent(new CustomEvent("mqtt1Rx1", JSON.stringify(payload) ));
        document.dispatchEvent(new CustomEvent("mqtt1Rx1", {
            bubbles: true,
            detail: {
              topic: topic,
              message: message.toString(),
            }
          } ));
    });
    }
  }, [client]);

  const mqttDisconnect = () => {
    if (client) {
      client.end(() => {
        setConnectStatus('Connect');
      });
    }
  }

  const mqttPublish = (context) => {
    if (client) {
      const { topic, qos, payload } = context;
      client.publish(topic, payload, { qos }, error => {
        if (error) {
          console.log('Publish error: ', error);
        }
      });
    }
  }

  const mqttSub = (subscription) => {
    if (client) {
      const { topic, qos } = subscription;
      client.subscribe(topic, { qos }, (error) => {
        if (error) {
          console.log('Subscribe to topics error', error)
          return
        }
        setIsSub(true)
      });
    }
  };

  const mqttUnSub = (subscription) => {
    if (client) {
      const { topic } = subscription;
      client.unsubscribe(topic, error => {
        if (error) {
          console.log('Unsubscribe error', error)
          return
        }
        setIsSub(false);
      });
    }
  };

  return (
    <>
      <Connection connect={mqttConnect} disconnect={mqttDisconnect} connectBtn={connectStatus} />
      <QosOption.Provider value={qosOption}>
        <Subscriber sub={mqttSub} unSub={mqttUnSub} showUnsub={isSubed} />
        <Publisher publish={mqttPublish} />
      </QosOption.Provider>
      {/* <Receiver payload={payload}/> */}
    </>
  );
}

export default Header2;

